<div>
    <span class="center text-neutral"> {{ 'reservations.date-message' | translate }} </span>
    <mat-calendar
        (selectedChange)="onSelected($event)"
        [(selected)]="selected"
        [dateFilter]="dateFilter"
        [headerComponent]="calendarHeaderComponent"
        [minDate]="CURRENT_DATE"
        [maxDate]="max_date"
        >
    </mat-calendar>
</div>
